module.exports = __webpack_public_path__ + "img/f_01.0fd38d7.png";